import { Controller } from "@api/config";

import type {
	ICreatePostAsyncRequest,
	IDeletePostRequest,
	IGetPostListRequest,
	IUpdatePostAsyncRequest,
} from "./request.types";
import type { TGetPostListResponse } from "./response.types";

class ModelCamPostsController extends Controller {
	public constructor() {
		super({ requestUrl: "models/post" });
	}

	/** @GET ALL POSTS */
	public async getPostListAsync({ page = 1, limit = 100, filter = "all", token }: IGetPostListRequest) {
		return this.get<TGetPostListResponse>("base", `?page=${page || 1}&limit=${limit}&filter=${filter}`, { token });
	}

	/** @POST CREATE POST */
	public async createPostAsync({ formData, token }: ICreatePostAsyncRequest) {
		return this.post<void>("", formData, { token, contentType: "multipart/form-data" });
	}

	/** @PUT UPDATE POST */
	public async updatePostAsync({ postId, formData, token }: IUpdatePostAsyncRequest) {
		return this.post<void>(`/${postId}`, formData, { token, contentType: "multipart/form-data" });
	}

	/** @DELETE POST */
	public async deletePostAsync({ postId, token }: IDeletePostRequest) {
		return this.delete<void>(`/${postId}`, { token });
	}
}

export const modelCamPostsAPI = new ModelCamPostsController();
